import { DataLayer } from "@grandvisionhq/analytics";
import { isSubscriptionPurchase, isInStoreSubscriptionPurchase } from "../../../../../../types/types/typeguards.js";
const SUBSCRIPTION_EVENT = "subscription_interaction";
const SUBSCRIPTION_FEATURE = "subscription";
const pushDeliveryIntervalSelectionEvent = (deliveryInterval) => {
  DataLayer.pushEvent({
    event: SUBSCRIPTION_EVENT,
    site_feature: SUBSCRIPTION_FEATURE,
    interaction_type: "choose_delivery_interval",
    delivery_interval: deliveryInterval
  });
};
const getInteractionEventType = (purchaseType) => {
  if (isSubscriptionPurchase(purchaseType)) {
    return "choose_subscription";
  }
  if (isInStoreSubscriptionPurchase(purchaseType)) {
    return "choose_instore_subscription";
  }
  return "choose_single_purchase";
};
const pushPurchaseTypeSelectionEvent = (purchaseType) => {
  DataLayer.pushEvent({
    event: SUBSCRIPTION_EVENT,
    site_feature: SUBSCRIPTION_FEATURE,
    interaction_type: getInteractionEventType(purchaseType)
  });
};
export {
  pushDeliveryIntervalSelectionEvent,
  pushPurchaseTypeSelectionEvent
};
//# sourceMappingURL=subscription-events.js.map
